module.exports = __webpack_public_path__ + "static/media/singlebed_fisdom.a931a843.svg";